<template>
  <div class="eni-for-footer">
    <div class="eni-for-footer-content">
      <div class="left">{{$ml.get('footer').eni}}</div>
      <div class="right">
        <a :href="$ml.get('footer').termini_link">{{$ml.get('footer').termini}}</a>
        <a :href="$ml.get('footer').privacy_link">{{$ml.get('footer').privacy}}</a>
        <a :href="$ml.get('footer').cookie_link">{{$ml.get('footer').cookie}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
.eni-for-footer {
  background: black;
  color: white;
  font-weight: 600;
  .eni-for-footer-content {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0.8em;
    a,
    .left {
      margin: 0 1em;
      font-family: "Avenir Next";
      font-size: 14px;
      font-weight: 700;
      letter-spacing: normal;
      color: white;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media (max-width: 720px) {
  .eni-for-footer {
    .eni-for-footer-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
        a {
          margin: 5px 0;
        }
      }
    }
  }
}
</style>
